import { Clock, CheckCircle2, Truck, Receipt, XCircle } from "lucide-react";

/**
 * Status filter bar for OrdersTab. Styled to match the Dispatch sub-tab
 * pattern: underlined pill row that gives each status a clear visual
 * identity, an icon, and a live count badge.
 */
const FILTERS = [
  { key: "pending",    label: "Pending",    icon: Clock,        accent: "text-yellow-700",  border: "border-yellow-600" },
  { key: "approved",   label: "Approved",   icon: CheckCircle2, accent: "text-blue-700",    border: "border-blue-600" },
  { key: "dispatched", label: "Dispatched", icon: Truck,        accent: "text-green-700",   border: "border-green-600" },
  { key: "invoiced",   label: "Invoicing",   icon: Receipt,      accent: "text-purple-700",  border: "border-purple-600" },
  { key: "canceled",   label: "Canceled",   icon: XCircle,      accent: "text-red-700",     border: "border-red-600" },
];

export default function OrderFilters({ statusFilter, onChange, allOrders }) {
  return (
    <div className="flex gap-1 border-b border-neutral-200 flex-wrap w-full">
      {FILTERS.map(({ key, label, icon: Icon, accent, border }) => {
        const count = allOrders.filter((o) => o.status === key).length;
        const isActive = statusFilter === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            data-testid={`${key}-orders-button`}
            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 border-b-2 transition-colors -mb-px ${
              isActive
                ? `${border} ${accent}`
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
            <span
              className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] font-mono font-semibold ${
                isActive ? "bg-neutral-900 text-white" : "bg-neutral-100 text-neutral-600"
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
